import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import { useDayJs } from 'tradera-hooks/use-day-js';
import { logger } from 'packages/logger';
import Analytics from 'packages/analytics';
import uiActions from 'tradera-state/ui/actions';
import CookieUtil from 'tradera-utils/cookie';
import {
    GDPR_CONSENT_COOKIE,
    GDPR_CONSENT_ALERT_DISMISSED
} from 'tradera-constants/cookies';
import GdprSettings from 'tradera-utils/gdpr-settings';
import GdprModal from 'tradera-components/alerts/gdpr/gdpr-modal';
import GdprSettingsModal from 'tradera-components/alerts/gdpr/gdpr-settings-modal';
import { useIsFeatureEnabled } from 'tradera-hooks/use-is-feature-enabled';

const GdprContainer = props => {
    const {
        visibleModal,
        visibleSettings,
        closeModal,
        openSettings,
        closeSettings
    } = props;

    const isQuantcastConsentEnabled = useIsFeatureEnabled('quantcast-consent');
    const dayjs = useDayJs();

    const openGdprSettings = event => {
        if (event) event.preventDefault();
        openSettings();
    };

    const acceptAndHide = (
        performance = true,
        functional = true,
        marketing = true,
        eventLabel
    ) => {
        GdprSettings.set(performance, functional, marketing);
        CookieUtil.createCookie(
            GDPR_CONSENT_ALERT_DISMISSED,
            1,
            dayjs()
                .add(1, 'years')
                .toDate()
        );
        closeSettings();
        closeModal();
        // Only track event and reload if cookie settings allow tracking
        if (performance) {
            trackEvent(eventLabel)
                .then(() => location.reload(true))
                .catch(error => logger(error));
        }
    };

    const trackEvent = (label = 'Save') => {
        return new Promise(resolve => {
            Analytics.trackEvent({
                category: 'Settings',
                action: 'Cookies',
                label,
                hitCallback: resolve
            });
        });
    };

    const hasGdprCookie = CookieUtil.hasCookie(GDPR_CONSENT_COOKIE);
    // Default to all toggled on if settings have never been set
    const gdprSettings = hasGdprCookie
        ? {
              performance: GdprSettings.isPerformanceEnabled(),
              functional: GdprSettings.isFunctionalEnabled(),
              marketing: GdprSettings.isMarketingEnabled()
          }
        : {
              performance: true,
              functional: true,
              marketing: true
          };

    return !isQuantcastConsentEnabled ? (
        <Fragment>
            {visibleModal && (
                <GdprModal
                    openGdprSettings={openGdprSettings}
                    acceptAndHide={acceptAndHide}
                />
            )}
            {visibleSettings && (
                <GdprSettingsModal
                    gdprSettings={gdprSettings}
                    saveHandler={acceptAndHide}
                />
            )}
        </Fragment>
    ) : null;
};

const mapStateToProps = state => ({
    visibleModal: state.ui.gdpr.modalOpen,
    visibleSettings: state.ui.gdpr.settingsOpen
});

const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(uiActions.closeGdprModal()),
    openSettings: () => dispatch(uiActions.openGdprSettings()),
    closeSettings: () => dispatch(uiActions.closeGdprSettings())
});

export default connect(mapStateToProps, mapDispatchToProps)(GdprContainer);
